module.exports = __webpack_public_path__ + "static/wendays-ea7bb64dbe9d68d9147455c055b338a6.svg";